import { Col, Row } from 'reactstrap';
import React, { useCallback } from 'react';
import SearchInput from 'components/SearchInput';
import { useApiGet } from 'hooks/useApi';
import Pagination from 'models/Pagination';
import PaginationNav from 'components/Pagination';
import Table from 'components/Table';
import { Column } from 'components/Table/_presenters/props/tableComponentProps';
import { AdminNotificationRead } from 'models/AdminNotificationRead';
import moment from 'moment';

const AdminNotificationReadsListPage = () => {
  const [filteredData, setFilteredData] = React.useState({
    pageSize: 10,
    page: 1,
    search: ''
  });

  const { data: readsPage, isLoading } = useApiGet<
    Pagination<AdminNotificationRead>
  >('/admin/notifications/reads', {
    params: filteredData
  });

  const handleSearch = useCallback(
    (search: string) => {
      setFilteredData({ ...filteredData, search, page: 1 });
    },
    [filteredData]
  );

  const handleClearFilter = useCallback(() => {
    setFilteredData({ pageSize: 10, page: 1, search: '' });
  }, []);

  const handlePageChange = useCallback(
    (page: number) => {
      setFilteredData({ ...filteredData, page });
    },
    [filteredData]
  );

  const columns: Column<AdminNotificationRead>[] = [
    {
      accessor: 'notification' as keyof AdminNotificationRead,
      label: 'Notificação',
      render: (_: any, read: AdminNotificationRead) => (
        <span className="fw-medium">{read.notification?.title || '-'}</span>
      )
    },
    {
      accessor: 'user' as keyof AdminNotificationRead,
      label: 'Usuário',
      render: (_: any, read: AdminNotificationRead) => (
        <span>{read.user?.email || '-'}</span>
      )
    },
    {
      accessor: 'createdAt',
      label: 'Data',
      render: (date) => <span>{moment(String(date)).format('LLL')}</span>
    }
  ];

  return (
    <div className="padding-page">
      <Row className="d-flex flex-column flex-md-row">
        <Col className="col-12 col-md">
          <div>
            <p className="text-gray-600">Administração</p>
            <h4 className="fw-bold">Leituras de Notificações</h4>
            <span className="small-typography text-gray-600">
              Visualize as leituras de notificações dos usuários.
            </span>
          </div>
        </Col>
      </Row>
      <Row className="d-flex align-items-center mt-2 flex-column flex-md-row">
        <Col className="col-12 col-md">
          <SearchInput
            onClearFilter={handleClearFilter}
            onSearchTextChange={handleSearch}
            placeholder="Buscar por usuário ou notificação"
          />
        </Col>
      </Row>
      <Table
        data={readsPage?.items || []}
        columns={columns}
        isLoading={isLoading}
      />
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row mt-3">
        {readsPage && (
          <PaginationNav
            onChange={handlePageChange}
            totalPages={readsPage.totalPages}
            currentPage={readsPage.page}
          />
        )}
      </div>
    </div>
  );
};

export default AdminNotificationReadsListPage;
